import { useEffect } from 'react';
import {
  isForeignTextInputForDialer,
  mapKeyboardEventToDialDigit,
} from '@/lib/callCenter/dialerKeyboard';

export interface UseDialerPhysicalKeyboardOptions {
  /** Si es false no se registra el listener. */
  enabled: boolean;
  onDigit: (digit: string) => void;
  onBackspace: () => void;
}

/**
 * Teclado físico: 0–9, * y # (incl. teclado numérico), Retroceso fuera del campo número.
 * No interfiere con inputs de texto ajenos ni con el `TextField` del número (`data-sf-dialer-number-field`).
 */
export function useDialerPhysicalKeyboard({
  enabled,
  onDigit,
  onBackspace,
}: UseDialerPhysicalKeyboardOptions): void {
  useEffect(() => {
    if (!enabled) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.repeat) return;

      if (isForeignTextInputForDialer(e.target)) {
        return;
      }

      if (e.key === 'Backspace') {
        e.preventDefault();
        onBackspace();
        return;
      }

      const digit = mapKeyboardEventToDialDigit(e);
      if (!digit) return;
      e.preventDefault();
      onDigit(digit);
    };

    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [enabled, onDigit, onBackspace]);
}
